export default "__VITE_ASSET__BwOw4k4Q__"